module.exports = __webpack_public_path__ + "img/navbar-icon-bell.014173a1.svg";